import { BigNumber } from 'bignumber.js';
import { stripHexPrefix } from '@ethereumjs/util';
import { isHexString } from '@particle-network/auth';
import BN from 'bn.js';
import numbro from 'numbro';
export function isEIP1559Type(type) {
    if (typeof type == 'number') {
        return type === 2;
    }
    else if (typeof type == 'string' && isHexString(type)) {
        return Number(type) === 2;
    }
    return false;
}
export function bnToHex(value) {
    return `0x${value.toString(16)}`;
}
export function toWei(amount, unit = 'ether') {
    if (!amount) {
        return new BN(0);
    }
    const ethjs = require('ethjs-unit');
    return ethjs.toWei(amount, unit);
}
export function isNullish(value) {
    return value === null || value === undefined;
}
export function fromWeiFormat(amount, unit = 'ether', mantissa = 6) {
    if (!amount) {
        return '0';
    }
    const ethjs = require('ethjs-unit');
    let result;
    if (typeof amount === 'string' && amount.startsWith('0x')) {
        result = ethjs.fromWei(new BN(stripHexPrefix(amount), 16), unit);
    }
    else {
        result = ethjs.fromWei(amount, unit);
    }
    return numbro(result).format({
        thousandSeparated: true,
        trimMantissa: true,
        mantissa: mantissa,
    });
}
export var GasFeeMode;
(function (GasFeeMode) {
    GasFeeMode["custom"] = "custom";
    GasFeeMode["low"] = "low";
    GasFeeMode["medium"] = "medium";
    GasFeeMode["high"] = "high";
})(GasFeeMode || (GasFeeMode = {}));
export function formatPrice(amount, price, mantissa) {
    const value = new BigNumber(amount).multipliedBy(new BigNumber(price));
    if (isNullish(mantissa)) {
        if (value.lt(new BigNumber(1))) {
            mantissa = 8;
        }
        else {
            mantissa = 2;
        }
    }
    return `≈$${numbro(value).format({
        thousandSeparated: true,
        trimMantissa: true,
        mantissa: mantissa,
    })}`;
}
const formatDisplayPrice = (fee, prices) => {
    return prices.length > 0 && prices[0].currencies && prices[0].currencies.length > 0 ? formatPrice(fee, prices[0].currencies[0].price, 2) : '';
};
const gasFee = (params, prices) => {
    const { gasLimit, baseFee, maxFeePerGas, maxPriorityFeePerGas, gasPrice } = params;
    if (maxFeePerGas && maxPriorityFeePerGas) {
        //eip 1559
        const fee = new BN(stripHexPrefix(maxPriorityFeePerGas), 16).add(new BN(stripHexPrefix(baseFee), 16)).mul(new BN(stripHexPrefix(gasLimit), 16));
        const maxFee = new BN(stripHexPrefix(maxFeePerGas), 16).add(new BN(stripHexPrefix(baseFee), 16)).mul(new BN(stripHexPrefix(gasLimit), 16));
        return {
            fee: fromWeiFormat(fee),
            feeFormatValue: formatDisplayPrice(fromWeiFormat(fee), prices),
            maxFee: fromWeiFormat(maxFee),
            maxFeeFormatValue: formatDisplayPrice(fromWeiFormat(maxFee), prices),
        };
    }
    else if (gasPrice) {
        const fee = new BN(stripHexPrefix(gasPrice), 16).mul(new BN(stripHexPrefix(gasLimit), 16));
        return {
            maxFee: fromWeiFormat(fee),
            maxFeeFormatValue: formatDisplayPrice(fromWeiFormat(fee), prices),
        };
    }
    return {
        maxFee: '',
    };
};
const totalAmount = (params) => {
    let { value, gasLimit, baseFee, maxFeePerGas, maxPriorityFeePerGas, gasPrice } = params;
    if (!value) {
        value = '0x0';
    }
    if (maxFeePerGas && maxPriorityFeePerGas) {
        //eip 1559
        const fee = new BN(stripHexPrefix(maxPriorityFeePerGas), 16).add(new BN(stripHexPrefix(baseFee), 16)).mul(new BN(stripHexPrefix(gasLimit), 16));
        const maxFee = new BN(stripHexPrefix(maxFeePerGas), 16).add(new BN(stripHexPrefix(baseFee), 16)).mul(new BN(stripHexPrefix(gasLimit), 16));
        return {
            amount: fromWeiFormat(new BN(stripHexPrefix(value), 16).add(fee)),
            maxAmount: fromWeiFormat(new BN(stripHexPrefix(value), 16).add(maxFee)),
        };
    }
    else if (gasPrice) {
        const fee = new BN(stripHexPrefix(gasPrice), 16).mul(new BN(stripHexPrefix(gasLimit), 16));
        return {
            maxAmount: fromWeiFormat(new BN(stripHexPrefix(value), 16).add(fee)),
        };
    }
    return {
        maxAmount: '',
    };
};
/**
 *
 * @param params
 * @returns
 */
export const gasNetworkFee = (params) => {
    const state = {
        value: {
            data: {
                maxFeePerGas: bnToHex(toWei(params.gasFee[GasFeeMode.high].maxFeePerGas, 'gwei')),
                maxPriorityFeePerGas: bnToHex(toWei(params.gasFee[GasFeeMode.high].maxPriorityFeePerGas, 'gwei')),
                gasLimit: params.gasLimit,
                gasPrice: '',
            },
            gasFeeMode: 'high',
            gasFee: params.gasFee,
            prices: params.prices,
            gasLimit: params.gasLimit,
        },
    };
    state.value.gasFee = params.gasFee;
    state.value.prices = params.prices;
    state.value.gasLimit = params.gasLimit;
    if (state.value.data) {
        if (params.evm1559support) {
            //eip 1559
            if (state.value.gasFeeMode && state.value.gasFeeMode !== GasFeeMode.custom) {
                // @ts-ignore
                state.value.data.maxFeePerGas = bnToHex(toWei(state.value.gasFee[state.value.gasFeeMode].maxFeePerGas, 'gwei'));
                // @ts-ignore
                state.value.data.maxPriorityFeePerGas = bnToHex(toWei(state.value.gasFee[state.value.gasFeeMode].maxPriorityFeePerGas, 'gwei'));
            }
            else if (!state.value.data.maxFeePerGas || !state.value.data.maxPriorityFeePerGas) {
                state.value.data.maxFeePerGas = bnToHex(toWei(state.value.gasFee.medium.maxFeePerGas, 'gwei'));
                state.value.data.maxPriorityFeePerGas = bnToHex(toWei(state.value.gasFee.medium.maxPriorityFeePerGas, 'gwei'));
                state.value.gasFeeMode = GasFeeMode.medium;
            }
        }
        else {
            if (state.value.gasFeeMode && state.value.gasFeeMode !== GasFeeMode.custom) {
                // @ts-ignore
                state.value.data.gasPrice = bnToHex(toWei(state.value.gasFee[state.value.gasFeeMode].maxFeePerGas, 'gwei'));
            }
            else if (!state.value.data.gasPrice) {
                state.value.data.gasPrice = bnToHex(toWei(state.value.gasFee.medium.maxFeePerGas, 'gwei'));
                state.value.gasFeeMode = GasFeeMode.medium;
            }
        }
        if (!state.value.data.gasLimit || state.value.gasFeeMode !== GasFeeMode.custom || state.value.data.gasLimit < state.value.gasLimit) {
            state.value.data.gasLimit = state.value.gasLimit;
        }
        const value = state.value;
        if (value.data && value.gasFee) {
            const gasFeeDisplay = gasFee({
                gasLimit: value.data.gasLimit,
                baseFee: bnToHex(toWei(value.gasFee.baseFee, 'gwei')),
                maxFeePerGas: value.data.maxFeePerGas,
                maxPriorityFeePerGas: value.data.maxPriorityFeePerGas,
                gasPrice: value.data.gasPrice,
            }, params.prices);
            value.gasFeeDisplay = gasFeeDisplay;
            const totalAmountDisplay = totalAmount({
                value: value.data.value,
                gasLimit: value.data.gasLimit,
                baseFee: bnToHex(toWei(value.gasFee.baseFee, 'gwei')),
                maxFeePerGas: value.data.maxFeePerGas,
                maxPriorityFeePerGas: value.data.maxPriorityFeePerGas,
                gasPrice: value.data.gasPrice,
            });
            value.totalAmountDisplay = totalAmountDisplay;
        }
        return value.gasFeeDisplay;
    }
    return {};
};
//# sourceMappingURL=networkFees.js.map